/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */
import React from 'react';
import ErrorPage from 'components/shared/ErrorPage/ErrorPage';

const headingContent = 'Missing Information: Date of Birth';

const MissingInfoErrorPage = () => (
  <ErrorPage summaryMessage={headingContent}>
    <div className="error-page-message-wide">
      <i>
        {' '}
        Please{' '}
        <a
          className="error-page-link"
          href="https://www.troweprice.com/personal-investing/help/contact/index.html"
          target="_blank"
          rel="noreferrer">
          contact us
        </a>{' '}
        to update your information over the phone
      </i>
    </div>
  </ErrorPage>
);

export default MissingInfoErrorPage;
